import { computed } from "vue";
import { mergeClassProp } from "@/runtime/style-engine/define-variants";
import type { ComboboxSeparatorProps } from "./combobox.types";
import { comboboxSeparatorClasses } from "./combobox.styles";

export interface UseComboboxSeparatorOptions {
  props: Readonly<ComboboxSeparatorProps>;
}

export const useComboboxSeparator = (options: UseComboboxSeparatorOptions) => {
  const { props } = options;
  const classes = computed(() => mergeClassProp(comboboxSeparatorClasses({}), props.class));
  return { classes };
};
